import { render, staticRenderFns } from "./SimpleHeader.vue?vue&type=template&id=57a46194&"
import script from "./SimpleHeader.vue?vue&type=script&lang=js&"
export * from "./SimpleHeader.vue?vue&type=script&lang=js&"
import style0 from "./SimpleHeader.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports